import { ClipboardList } from "lucide-react";
import AuthShell, { AUTH_TITLE_CLASS } from "@/components/AuthShell";
import { TEKS_TAUTAN_BERUBAH } from "@/lib/survei";

// Alamat lama /survei: TIDAK lagi memuat survei & tidak memanggil API apa pun (tidak ada alamat tetap ke periode aktif).
// Tanpa pengalihan otomatis -- peserta memakai tautan per periode dari UFP (/survei-peserta-didik-<kode>).
export default function SurveiTautanBerubah() {
    return (
        <AuthShell>
            <div className="space-y-4" data-testid="survei-tautan-berubah">
                <h1 className={`${AUTH_TITLE_CLASS} flex items-center gap-2 text-xl`}>
                    <ClipboardList aria-hidden="true" className="h-6 w-6 shrink-0" /> Survei Kepuasan Peserta Didik
                </h1>
                <p className="text-sm text-foreground">{TEKS_TAUTAN_BERUBAH}</p>
            </div>
        </AuthShell>
    );
}
